import moment from 'moment';
import RestService from '../services/rest';

async function getOutboundLoads(
  startDate,
  endDate,
) {
  const sDate = moment(startDate).format();
  const eDate = moment(endDate).format();

  return RestService.getAuthenticated('outboundLoads/getOutboundLoads', {
    startDate: sDate, endDate: eDate,
  });
}

// BEES-3943 - uma carga no formato da lista do monitor, para atualizar so a
// linha afetada apos vincular, alterar ou remover a doca.
async function getOutboundLoad(
  outboundLoadId,
) {
  return RestService.getAuthenticated('outboundLoads/getOutboundLoad', {
    outboundLoadId,
  });
}

async function getLoadOrders(
  outboundLoadId,
) {
  return RestService.getAuthenticated('outboundLoads/getLoadOrders', {
    outboundLoadId,
  });
}

async function toggleLoadPriority(
  outboundLoadId,
  isUrgent,
) {
  return RestService.postAuthenticated('outboundLoads/toggleLoadPriority', {
    outboundLoadId,
    isUrgent,
  });
}

async function linkDock(
  outboundLoadId,
  dockCode,
) {
  return RestService.postAuthenticated('outboundLoads/linkDock', {
    outboundLoadId,
    dockCode,
  });
}

async function unlinkDock(
  outboundLoadId,
) {
  return RestService.postAuthenticated('outboundLoads/unlinkDock', {
    outboundLoadId,
  });
}

async function changeDock(
  outboundLoadId,
  dockCode,
) {
  return RestService.postAuthenticated('outboundLoads/changeDock', {
    outboundLoadId,
    dockCode,
  });
}
async function verifyDockControl(
  outboundLoadId,
  dockCode,
) {
  return RestService.getAuthenticated('outboundLoads/verifyDockControl', {
    outboundLoadId,
    dockCode,
  });
}

async function cancelOutboundLoad(
  outboundLoadId,
) {
  return RestService.postAuthenticated('outboundLoads/cancelOutboundLoad', {
    outboundLoadId,
  });
}

export default {
  getOutboundLoads,
  getOutboundLoad,
  getLoadOrders,
  toggleLoadPriority,
  linkDock,
  unlinkDock,
  verifyDockControl,
  cancelOutboundLoad,
  changeDock,
};
